import { Action, createReducer, on } from '@ngrx/store';
import * as NotificationActions from './notifications.actions';
import { NotificationsState, initialStateNotifications } from './notifications.models';

import { cloneDeep } from 'lodash-es';

export const NOTIFICATIONS_FEATURE_KEY = 'notifications';

const reducer = createReducer(
  initialStateNotifications,
  on(NotificationActions.setNotifications, (state, { personalNotificaitons, scheludedNotifications }) => {
    let countNotifications = 0;

    const clonedNotis = cloneDeep(personalNotificaitons);

    clonedNotis.forEach((notification) => {
      if (!notification.viewed) {
        countNotifications = countNotifications + 1;
      }
    });

    clonedNotis.sort((a, b) => (a.executeOn > b.executeOn ? 1 : -1)).sort((a, b) => (a.viewed > b.viewed ? 1 : -1));

    return {
      ...state,
      listOfNotifications: clonedNotis,
      scheduled: scheludedNotifications,
      count: countNotifications
    };
  }),
  on(NotificationActions.sendAction, (state, { actionType, notification }) => {
    return {
      ...state,
      actionOnNotification: {
        actionType,
        notification
      }
    };
  })
);

export function notificationsReducer(state: NotificationsState | undefined, action: Action) {
  return reducer(state, action);
}
